import uniq from 'lodash/uniq';

import { ProjectPropertyType } from 'src/constants/project';
import { ProjectModelProperty } from 'src/store/state/projects';
import { XSD_IRI } from 'src/templates/queries/iris';
import { ModelPropertyBindingResult } from 'src/templates/queries/modelProperties';

export type ImportedProjectModelProperty = Omit<
  ProjectModelProperty,
  'isDatatype'
> & {
  isAttribute?: boolean;
  isRelationship?: boolean;
};

export const parseModelPropertyResults = (
  results: ModelPropertyBindingResult[]
) =>
  Object.values(
    results.reduce<Record<string, ImportedProjectModelProperty>>(
      (acc, result) => {
        const iri = result.property?.value;
        if (!iri) {
          return acc;
        }

        if (!acc[iri]) {
          acc[iri] = {
            iri,
            domain: [],
            range: [],
            parents: [],
            propertyType: ProjectPropertyType.RDFS,
          };
        }

        const isDatatype = result.isDatatype?.value;
        if (isDatatype === 'true') {
          acc[iri].isAttribute = true;
        }

        if (isDatatype === 'false') {
          acc[iri].isRelationship = true;
        }

        const domain = result.domain?.value;
        if (domain) {
          acc[iri].domain = uniq([...acc[iri].domain, domain]);
        }

        const range = result.range?.value;
        if (range) {
          acc[iri].range = uniq([...acc[iri].range, range]);
        }

        const domainIncludes = result.domainIncludes?.value;
        if (domainIncludes) {
          acc[iri].domain = uniq([...acc[iri].domain, domainIncludes]);
          acc[iri].propertyType = ProjectPropertyType.SCHEMA_ORG;
        }

        const rangeIncludes = result.rangeIncludes?.value;
        if (rangeIncludes) {
          acc[iri].range = uniq([...acc[iri].range, rangeIncludes]);
          acc[iri].propertyType = ProjectPropertyType.SCHEMA_ORG;
        }

        const parent = result.parent?.value;
        if (parent) {
          acc[iri].parents = uniq([...acc[iri].parents, parent]);
        }

        return acc;
      },
      {}
    )
  ).reduce<Record<string, ImportedProjectModelProperty>>((acc, result) => {
    acc[result.iri] = {
      ...result,
      isAttribute:
        result.isAttribute ??
        (!result.isRelationship && result.range.length
          ? result.range.every((range) => range.startsWith(XSD_IRI))
          : undefined),
    };
    return acc;
  }, {});
